import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["animation: ", " ", ";"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  white-space: ", ";\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  border: none;\n  cursor: ", ";\n  outline: none;\n  margin: 0;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useCallback, useImperativeHandle } from 'react';
import styled, { css } from 'styled-components';
import { BUTTON_SHAKE_ANIMATION_DURATION } from '../constants';
import { getMs } from '../../helpers/common';
import { ellipsisDisplayMixin, ellipsisKeys, fullWidthKeys, fullWidthMixin } from '../../mixins/layout';
import { withOmitProps } from '../../helpers/elements';
import { useDeviceType, useToggleFlag } from '../../hooks';
import { isDefined } from '../../helpers/defined';
import { setNoFocus } from '../../helpers/events-focus';
import { activePressedStyle } from '../../tokens/pressed';
import { userSelectNoneStyle } from '../../tokens/user-select';
import { appearanceNoneStyle } from '../../tokens/appearance';
import { buttonShakeAnimationKeyframes } from '../style/animation';
import { buttonWithPrefixStyle, buttonWithPrefixVerticalStyle, buttonWithSuffixStyle, buttonWithSuffixVerticalStyle } from '../style/modification';
import { buttonTransitionStyle } from '../style/transition';
import { buttonTextColorKeys, buttonTextColorMixin } from '../style/text-color';
import { buttonIconsColorKeys, buttonIconsColorMixin } from '../style/icons-color';
import { buttonBorderColorKeys, buttonBorderColorMixin } from '../style/border-color';
import { buttonBackgroundColorKeys, buttonBackgroundColorMixin } from '../style/background-color';
import { buttonBoxShadowKeys, buttonBoxShadowMixin } from '../style/box-shadow';
import { styleForBreakpoints } from '../../helpers/media-style';
import { baseHighlightStyle } from '../../tokens/highlight';
import { width } from '../../style/width';
var buttonBaseStyle = css(_templateObject(), function (_ref) {
  var $noWrap = _ref.$noWrap;
  return $noWrap ? 'nowrap' : 'normal';
}, function (_ref2) {
  var disabled = _ref2.disabled,
      inactive = _ref2.inactive;
  return disabled || inactive ? 'default' : 'pointer';
}, buttonTransitionStyle, baseHighlightStyle, userSelectNoneStyle, appearanceNoneStyle, function (_ref3) {
  var $noPadding = _ref3.$noPadding;
  return $noPadding ? "padding: 0 !important;" : '';
}, function (_ref4) {
  var inactive = _ref4.inactive,
      disabled = _ref4.disabled,
      $noTransform = _ref4.$noTransform;
  return !inactive && !disabled && !$noTransform && activePressedStyle;
}, function (_ref5) {
  var disabled = _ref5.disabled,
      inactive = _ref5.inactive,
      $animated = _ref5.$animated,
      $noAnimate = _ref5.$noAnimate,
      $withManualShakingTrigger = _ref5.$withManualShakingTrigger;
  return (
    /* prettier-ignore */
    (disabled || $withManualShakingTrigger) && !inactive && $animated && !$noAnimate && css(_templateObject2(), buttonShakeAnimationKeyframes, getMs(BUTTON_SHAKE_ANIMATION_DURATION))
  );
});
var StyledButton = styled.button.withConfig(withOmitProps([].concat(fullWidthKeys, ellipsisKeys, buttonTextColorKeys, buttonIconsColorKeys, buttonBorderColorKeys, buttonBackgroundColorKeys, buttonBoxShadowKeys, ['hasTouch', 'inactive', 'width'])))(_templateObject3(), buttonBaseStyle, buttonTextColorMixin, buttonIconsColorMixin, buttonBorderColorMixin, buttonBackgroundColorMixin, buttonBoxShadowMixin, fullWidthMixin, ellipsisDisplayMixin, function (_ref6) {
  var value = _ref6.width;
  return isDefined(value) ? width(value) : '';
}, function (_ref7) {
  var $withPrefix = _ref7.$withPrefix,
      $vertical = _ref7.$vertical;
  return styleForBreakpoints($vertical, function ($vertical) {
    return $withPrefix ? $vertical ? buttonWithPrefixVerticalStyle : buttonWithPrefixStyle : '';
  });
}, function (_ref8) {
  var $withSuffix = _ref8.$withSuffix,
      $vertical = _ref8.$vertical;
  return styleForBreakpoints($vertical, function ($vertical) {
    return $withSuffix ? $vertical ? buttonWithSuffixVerticalStyle : buttonWithSuffixStyle : '';
  });
});
var ButtonBase = /*#__PURE__*/React.forwardRef(function (_ref9, forwardedRef) {
  var as = _ref9.as,
      forwardedAs = _ref9.forwardedAs,
      _ref9$noFocus = _ref9.noFocus,
      noFocus = _ref9$noFocus === void 0 ? false : _ref9$noFocus,
      _ref9$noAnimate = _ref9.noAnimate,
      noAnimate = _ref9$noAnimate === void 0 ? false : _ref9$noAnimate,
      _ref9$withManualShaki = _ref9.withManualShakingTrigger,
      withManualShakingTrigger = _ref9$withManualShaki === void 0 ? false : _ref9$withManualShaki,
      _ref9$noTransform = _ref9.noTransform,
      noTransform = _ref9$noTransform === void 0 ? false : _ref9$noTransform,
      _ref9$noWrap = _ref9.noWrap,
      noWrap = _ref9$noWrap === void 0 ? false : _ref9$noWrap,
      _ref9$noPadding = _ref9.noPadding,
      noPadding = _ref9$noPadding === void 0 ? false : _ref9$noPadding,
      _ref9$disabled = _ref9.disabled,
      disabled = _ref9$disabled === void 0 ? false : _ref9$disabled,
      _ref9$inactive = _ref9.inactive,
      inactive = _ref9$inactive === void 0 ? false : _ref9$inactive,
      _ref9$vertical = _ref9.vertical,
      vertical = _ref9$vertical === void 0 ? false : _ref9$vertical,
      _ref9$withPrefix = _ref9.withPrefix,
      withPrefix = _ref9$withPrefix === void 0 ? false : _ref9$withPrefix,
      _ref9$withSuffix = _ref9.withSuffix,
      withSuffix = _ref9$withSuffix === void 0 ? false : _ref9$withSuffix,
      onClick = _ref9.onClick,
      onDisabledClick = _ref9.onDisabledClick,
      children = _ref9.children,
      props = _objectWithoutPropertiesLoose(_ref9, ["as", "forwardedAs", "noFocus", "noAnimate", "withManualShakingTrigger", "noTransform", "noWrap", "noPadding", "disabled", "inactive", "vertical", "withPrefix", "withSuffix", "onClick", "onDisabledClick", "children"]);

  var _useDeviceType = useDeviceType(),
      hasTouchScreen = _useDeviceType.hasTouchScreen;

  var _useToggleFlag = useToggleFlag(BUTTON_SHAKE_ANIMATION_DURATION),
      animated = _useToggleFlag[0],
      toggleAnimated = _useToggleFlag[1];

  useImperativeHandle(forwardedRef, function () {
    return {
      toggleAnimated: toggleAnimated
    };
  });
  var onButtonClick = useCallback(!disabled ? onClick : function (e) {
    if (!noAnimate) {
      toggleAnimated();
    }

    onDisabledClick == null ? void 0 : onDisabledClick(e);
  }, [disabled, onClick, noAnimate, toggleAnimated, onDisabledClick]);
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    as: disabled && !noAnimate ? 'div' : forwardedAs || as || (props.href ? 'a' : undefined),
    ref: forwardedRef,
    onTouchStart: function onTouchStart() {},
    disabled: disabled,
    inactive: inactive,
    $vertical: vertical,
    $withPrefix: withPrefix,
    $withSuffix: withSuffix,
    onClick: onButtonClick,
    $animated: noAnimate ? false : animated,
    $noAnimate: noAnimate,
    $withManualShakingTrigger: withManualShakingTrigger,
    $noTransform: noTransform,
    $noWrap: noWrap,
    $noPadding: noPadding,
    $hasTouch: hasTouchScreen
  }, props, setNoFocus(props, noFocus)), children);
});
export default ButtonBase;